export const UNKNOWN_METRICS_VALUE = "Unknown";

export type MetricPayload = {
  Metric: {
      Name: string;       // Name of the metric
      Timestamp: string;  // ISO 8601 timestamp string
      Dimensions: {       // Flexible dictionary for dimensions
        [key: string]: string; // Key-value pairs with both key and value as strings
      };
      Value?: number;     // Optional numeric value of the metric
  };
};